import UpdateBookTimePage from "./update-book-time.page";

export default UpdateBookTimePage;
